import { Box, Container, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import { Trans, useTranslation } from "react-i18next";
import AuthContainer from "../../../components/Containers/AuthContainer.js";
import LoginForm from "./LoginForm.js";
import appcolors from "../../../constants/Colors.js";

const Login = () => {
  const { palette } = useTheme();
  const { t } = useTranslation(["authentication"]);

  return (
    <Box>
      <AuthContainer>
        <Container className={"lb-auth-container"} sx={{ mt: 2 }}>
          <Typography variant="auth_primary_text" component={"h1"}>
            {t("login")}
          </Typography>
          <Typography variant="auth_secondary_text" component={"p"}>
            <Trans
              i18nKey={t("welcomeLoginMessage")}
              components={{
                1: <strong style={{ color: "#000" }}>{t("eaziday")}</strong>
              }}
            />
          </Typography>

          {/* Login form component */}
          <LoginForm />
        </Container>
      </AuthContainer>
    </Box>
  );
};

export default Login;
